import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({
    company_name: 'i4 Solutions',
    company_logo_url: null,
    company_logo_small_url: null,
    primary_color: '#14b8a6',
    secondary_color: '#0f172a',
    login_title: 'Panel de Administración',
    footer_text: 'Powered by i4-Assets'
  });
  const [loading, setLoading] = useState(true);

  const fetchBranding = async (isPublic = true) => {
    try {
      const endpoint = isPublic ? '/branding/public' : '/branding';
      const response = await api.get(endpoint);
      setBranding(response.data);
    } catch (error) {
      console.error('Error fetching branding:', error);
      // Mantener valores por defecto
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBranding(true);
  }, []);

  const refreshBranding = () => fetchBranding(false);

  return (
    <BrandingContext.Provider value={{ branding, loading, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error('useBranding must be used within a BrandingProvider');
  }
  return context;
};
